module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "part-1-in-front-of-every-silver-lining-19641977"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Arial",
      "padding-top": "200px"
    }
  }, [_vm._v("Part 1 "), _c('br'), _vm._v("In Front of Every Silver Lining "), _c('br'), _vm._v("1964–1977")]), _vm._v(" "), _c('p', [_vm._v("Y"), _c('em', [_vm._v("ou cannot go back and change the beginning but you can start again from where you are and change the ending.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("C S Lewis")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 78
// module chunks = 0